var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCombiOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.335 478.762L240.335 423.834C246.334 420.213 250 413.717 250 406.711V295.289C250 288.283 246.334 281.787 240.335 278.166L149.335 223.238C142.979 219.402 135.021 219.402 128.665 223.238L37.6648 278.166C31.6664 281.787 28 288.283 28 295.289V406.711C28 413.717 31.6664 420.213 37.6648 423.834L128.665 478.762C135.021 482.598 142.979 482.598 149.335 478.762Z",
    stroke: "white",
    strokeWidth: 34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 284L139 351.5M139 351.5L250 284M139 351.5V485",
    stroke: "white",
    strokeWidth: 34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139 217V93.2889C139 86.2825 142.666 79.787 148.665 76.1663L239.665 21.2384C246.021 17.4018 253.979 17.4018 260.335 21.2384L462.335 143.166C468.334 146.787 472 153.282 472 160.289V406.711C472 413.717 468.334 420.213 462.335 423.834L371.335 478.762C364.979 482.598 357.021 482.598 350.665 478.762L259.665 423.834C253.666 420.213 250 413.718 250 406.711V149.5",
    stroke: "white",
    strokeWidth: 34,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148 87.5L250 149.25M361 216.5L459.5 156.5M361 216.5V469.5M361 216.5L250 149.25M250 149.25L344.5 92",
    stroke: "white",
    strokeWidth: 34,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCombiOutline);
export default __webpack_public_path__ + "static/media/ico_combi_outline.7ec2cc0ed557b853163c3fb8d116c0a1.svg";
export { ForwardRef as ReactComponent };